import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../atoms/icon-inline/nn-icon-inline.js';
/**
 * A mobile component with disconnected and connected html.
 * Component is empty in not connected mode
 * In connected mode, shows block with : user, userID, customer website link and logout button.
 *
 * connected - The Connected boolean variable. If true, connected block is shown
 * user - The user login used in connected mode.
 * userId - The user ID used in connected mode.
 * logoutUrl - The logout Connexion URL used in connected mode.
 * customerUrl - The customer website URL used in connected mode.
 */
@customElement('nn-mobile-connection')
export class MobileConnection extends LitElement {
  static styles = css`
    :host {
      width: 100%;
      --nn-icon-inline_icon-inline_color: #000;
      --nn-icon-inline_icon-inline_font-family: 'font-heavy';
      --nn-icon-inline_icon-inline_font-size: 1em;
    }
    .mobile-user--name {
      font-size: 1.5em;
      line-height: 1;
      margin: 30px 0 20px;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
    .mobile-user--id {
      color: var(--nn-mobile-connection_mobile-user--id_color, #d93939);
      font-family: 'font-heavy';
    }
    .mobile-user--link {
      color: var(--nn-mobile-connection_mobile-user--link_color, #000);
      display: block;
      margin: 30px 0;
      text-decoration: none;
      width: 100%;
    }
    .mobile-user--logout {
      text-align: center;
    }
    .mobile-cta,
    .mobile-cta:hover,
    .mobile-cta:active,
    .mobile-cta:focus,
    .mobile-cta:visited {
      align-items: center;
      background: var(--nn-mobile-connection_mobile-cta_background, #fff);
      border: 1px solid
        var(--nn-mobile-connection_mobile-cta_border-color, #7c7c7c);
      border-radius: 10px;
      color: var(--nn-mobile-connection_mobile-cta_color, #595959);
      display: inline-flex;
      font-family: 'font-medium';
      font-size: var(--nn-mobile-connection_mobile-cta_font-size, 1em);
      height: var(--nn-mobile-connection_mobile-cta_height, 41px);
      justify-content: center;
      padding: var(--nn-mobile-connection_mobile-cta_padding, 0 15px);
      text-decoration: none;
      width: var(--nn-mobile-connection_mobile-cta_width, 170px);
    }
    .mobile-user-informations {
      width: 100%;
    }
  `;

  @property({ type: Boolean }) connected = false;

  @property({ type: String }) user = 'My login';

  @property({ type: String }) userId = '000000000';

  @property({ type: String }) logoutUrl = 'https://nordnet.com#logout';

  @property({ type: String }) customerUrl = 'https://client.nordnet.com';

  render() {
    if (this.connected) {
      return html`
        <div class="mobile-user-informations">
          <div class="mobile-user--name">Bonjour ${this.user}</div>
          <div class="mobile-user--id">
            Numéro de client&nbsp;: ${this.userId}
          </div>
          <nn-link
            textLink="Mon Espace Client"
            idlink="mobile-connected-customer-link"
            hrefLink="${this.customerUrl}"
            class="mobile-user--link"
          >
            <svg
              slot="icon"
              class="img-responsive"
              width="25"
              height="26"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <title>Mon Espace Client</title>
              <path
                d="M8.19337 0.334351C5.93876 0.334351 4.10449 2.22319 4.10449 4.54488C4.10449 6.86656 5.93876 8.7554 8.19337 8.7554C10.448 8.7554 12.2823 6.86656 12.2823 4.54488C12.2823 2.22319 10.448 0.334351 8.19337 0.334351ZM8.19337 7.07119C6.84077 7.07119 5.74004 5.93772 5.74004 4.54488C5.74004 3.15203 6.84077 2.01856 8.19337 2.01856C9.54598 2.01856 10.6467 3.15203 10.6467 4.54488C10.6467 5.93772 9.54598 7.07119 8.19337 7.07119ZM14.7356 16.3344C15.1872 16.3344 15.5534 15.9682 15.5534 15.5166V15.4922C15.5534 12.2426 12.9847 9.59751 9.82893 9.59751H6.55782C3.4012 9.59751 0.833374 12.2426 0.833374 15.4922V15.5166C0.833374 15.9682 1.19951 16.3344 1.65115 16.3344C2.1028 16.3344 2.46893 15.9682 2.46893 15.5166V15.4922C2.46893 13.1706 4.30321 11.2817 6.55782 11.2817H9.82893C12.0835 11.2817 13.9178 13.1706 13.9178 15.4922V15.5166C13.9178 15.9682 14.2839 16.3344 14.7356 16.3344Z"
                fill="#000"
              />
            </svg>
            <span slot="text">Mon compte</span>
          </nn-link>

          <div class="mobile-user--logout">
            <a
              id="megamenu-logout-link"
              class="mobile-cta fill"
              href="${this.logoutUrl}"
              title="Me déconnecter"
            >
              Me déconnecter
            </a>
          </div>
        </div>
      `;
    }
    return html`<div class="separator"></div>`;
  }
}
